var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
import { Expose, Type } from 'class-transformer';
import { GkvBillingRunStatus } from '../enums/gkv-billing-run-status.enum.js';
/**
 * One row of the Abrechnungslauf history — date, who pressed the button, what
 * came of it. Clicking a row falls through to the status endpoint, so this DTO
 * carries no per-Fall detail.
 */
export class GkvBillingRunHistoryRowDto {
    id;
    status;
    /** ISO timestamp — the moment the operator pressed the button. */
    createdAt;
    startedAt;
    completedAt;
    /** ISO timestamp — the Stichtag the run was assembled with. */
    cutoff;
    /**
     * A Probelauf — every Nutzdatendatei forced to `UNB.0035 = T` (#1523).
     *
     * ⚠ **The only thing that tells a Testlauf from a real run afterwards.** Both
     * carry the same statuses, produce files and burn the transport counters; what
     * differs is invisible on any file row — the Rechnungsnummern came from the
     * `gkv-test` series and no Anspruchszeile was written, so the Fälle are still
     * billable. Without this field a practice looking at its Historie in March
     * could not say which of two `COMPLETED` runs actually claimed anything.
     */
    isTestRun;
    triggeredByUserId;
    executorFirstName;
    executorLastName;
    totalCount;
    successCount;
}
__decorate([
    Expose(),
    __metadata("design:type", String)
], GkvBillingRunHistoryRowDto.prototype, "id", void 0);
__decorate([
    Expose(),
    __metadata("design:type", String)
], GkvBillingRunHistoryRowDto.prototype, "status", void 0);
__decorate([
    Expose(),
    __metadata("design:type", String)
], GkvBillingRunHistoryRowDto.prototype, "createdAt", void 0);
__decorate([
    Expose(),
    __metadata("design:type", Object)
], GkvBillingRunHistoryRowDto.prototype, "startedAt", void 0);
__decorate([
    Expose(),
    __metadata("design:type", Object)
], GkvBillingRunHistoryRowDto.prototype, "completedAt", void 0);
__decorate([
    Expose(),
    __metadata("design:type", String)
], GkvBillingRunHistoryRowDto.prototype, "cutoff", void 0);
__decorate([
    Expose(),
    __metadata("design:type", Boolean)
], GkvBillingRunHistoryRowDto.prototype, "isTestRun", void 0);
__decorate([
    Expose(),
    __metadata("design:type", String)
], GkvBillingRunHistoryRowDto.prototype, "triggeredByUserId", void 0);
__decorate([
    Expose(),
    __metadata("design:type", Object)
], GkvBillingRunHistoryRowDto.prototype, "executorFirstName", void 0);
__decorate([
    Expose(),
    __metadata("design:type", Object)
], GkvBillingRunHistoryRowDto.prototype, "executorLastName", void 0);
__decorate([
    Expose(),
    __metadata("design:type", Number)
], GkvBillingRunHistoryRowDto.prototype, "totalCount", void 0);
__decorate([
    Expose(),
    __metadata("design:type", Number)
], GkvBillingRunHistoryRowDto.prototype, "successCount", void 0);
/**
 * Response of `GET /v1/office-locations/:officeLocationId/gkv-billing-run/history`
 * (TM-9538 / #1519).
 *
 * ⚠ **In-flight runs are in here, sorted to the top** — a departure from the
 * Mahnlauf, whose history is strictly terminal because its live sidebar owns
 * the running one. §302 has no such sidebar yet, and a run that has been
 * started but appears nowhere is a run nobody can find, cancel, or account for.
 */
export class GkvBillingRunHistoryResponseDto {
    rows;
    /** The unpaginated row count, for "Mehr laden". */
    total;
}
__decorate([
    Expose(),
    Type(() => GkvBillingRunHistoryRowDto),
    __metadata("design:type", Array)
], GkvBillingRunHistoryResponseDto.prototype, "rows", void 0);
__decorate([
    Expose(),
    __metadata("design:type", Number)
], GkvBillingRunHistoryResponseDto.prototype, "total", void 0);
//# sourceMappingURL=gkv-billing-run-history.response.dto.js.map